var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lexon-numeration-component" },
    [
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.innerValue,
                expression: "innerValue",
              },
            ],
            attrs: { type: "hidden" },
            domProps: { value: _vm.innerValue },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.innerValue = $event.target.value
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm.showGeneralSpinner
        ? _c("SpinnerLayerComponent", { staticClass: "general-spinner" })
        : _c(
            "div",
            {
              directives: [
                {
                  name: "resize",
                  rawName: "v-resize",
                  value: _vm.calculateCustomFieldsHeadersWidth,
                  expression: "calculateCustomFieldsHeadersWidth",
                },
              ],
              staticClass: "playground-area",
            },
            [
              _c("p", { staticClass: "info-text" }, [
                _vm._v(_vm._s(_vm.texts.infoText)),
              ]),
              _c(
                "div",
                { staticClass: "headers" },
                _vm._l(_vm.headers, function (header, headerIndex) {
                  return _c("span", { staticClass: "header" }, [
                    _vm._v(_vm._s(header)),
                  ])
                }),
                0
              ),
              _vm.numerationPattern &&
              _vm.numerationPattern.customFields &&
              _vm.numerationPattern.customFields.length
                ? _c("CustomFieldsListComponent", {
                    staticClass: "custom-fields-list",
                    attrs: { showButtons: _vm.newMode },
                    on: { "remove-field": _vm.removeField },
                    model: {
                      value: _vm.numerationPattern.customFields,
                      callback: function ($$v) {
                        _vm.$set(_vm.numerationPattern, "customFields", $$v)
                      },
                      expression: "numerationPattern.customFields",
                    },
                  })
                : _vm._e(),
              _vm.newMode
                ? _c("LexonAutocompleteComponent", {
                    key: _vm.componentKey,
                    staticClass: "add-new-autocomplete",
                    attrs: {
                      "prop-items": _vm.getPatternTypes,
                      placeholder: _vm.texts.addNewPattern,
                      clearable: false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.addNumerationPattern($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }